export const getWeekendShiftsTeams = () => `
SELECT 
  Structure__c
FROM 
  Case_Tree_Configuration__c 
WHERE 
  Id = 'a2G3j000001iTQbEAM'
`;
